import React from 'react';

import { BETA_FEATURES } from '@/constants/betaFeatures';
import useBetaFeature from '@/hooks/useBetaFeature';
import { BetaBadge, Toggle } from '@/ui';

import './styles.css';
import type { Props } from './types';

/**
 * One beta's row in App Settings, bound to the same saved choice as the
 * switch on the page it changes. Renders nothing while the beta offers no choice.
 */
const BetaFeatureSetting = ({ feature }: Props) => {
  const { isToggleVisible, isEnabled, setEnabled } = useBetaFeature(feature);

  if (!isToggleVisible) return null;

  const { description, label } = BETA_FEATURES[feature];

  return (
    <div className="flex w-fit flex-col gap-1">
      <span className="flex items-center gap-2 text-sm font-medium text-gray-700">
        {label}
        <BetaBadge />
      </span>
      <Toggle size="sm" checked={isEnabled} onChange={setEnabled} aria-label={`Use the ${label}`} />
      <span className="text-xs text-gray-500">{description}</span>
    </div>
  );
};

export default React.memo(BetaFeatureSetting);
